export const setUnidadesMeianoite = (state, payload) => {
    state.meianoite.unidades = payload;
};

export const setTaxaOcupacaoMeianoite = (state, payload) => {
    state.meianoite.txOcupacao = payload;
};

export const setMapaLeitos = (state, payload) => {
    state.pacientesInternados.mapaLeitos = payload;
};

export const setPacienteInternado = (state, payload) => {
    state.pacientesInternados.pacienteInternado = payload;
};

export const setErrorCns = (state, payload) => {
    state.errorCns = payload;
};

export const setHistoricoInternacoes = (state, payload) => {
    state.historicoInternacoes.historico = payload;
};

export const setHistoricoInternacoesError = (state, payload) => {
    state.historicoInternacoes.error = payload;
};

export const setHistoricoMovimentacao = (state, payload) => {
    state.historicoMovimentacao.movimentacao = payload;
};

export const setLongaPermanencia = (state, payload) => {
    state.longaPermanencia.ativos = payload;
};